import React, { ChangeEvent, FocusEvent } from "react";
import Typography from "../Typography";

interface LabelInputFieldProps {
  label?: string;
  placeHolder?: string;
  value?: string;
  style?: {
    container?: React.CSSProperties;
    label?: React.CSSProperties;
    input?: React.CSSProperties;
    iconContainer?: React.CSSProperties; // Container for the icon (left or right)
  };
  name: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  leftIcon?: React.ReactNode; // Icon to display on the left side of the input
  rightIcon?: React.ReactNode; // Icon to display on the right side of the input
  disabled?: boolean;
  ref?: any;
}

const LabelInputField: React.FC<LabelInputFieldProps> = ({
  ref,
  label,
  style,
  placeHolder,
  onChange,
  onBlur,
  value,
  name,
  leftIcon,
  rightIcon,
  disabled,
}) => {
  return (
    <div style={style?.container}>
      {label && (
        <Typography fontFamily="urbanist" style={style?.label}>
          {label}
        </Typography>
      )}
      <div
        style={{ display: "flex", alignItems: "center", position: "relative" }}
      >
        {leftIcon && (
          <div style={{ position: "absolute", left: 10, zIndex: 1 }}>
            {leftIcon}
          </div>
        )}
        <input
          ref={ref}
          placeholder={placeHolder}
          value={value}
          type={name === "password" ? "password" : "text"}
          onChange={onChange}
          onBlur={onBlur}
          style={{
            ...style?.input,
            paddingLeft: leftIcon ? "30px" : "10px", // Add space if there's a left icon
            paddingRight: rightIcon ? "30px" : "10px", // Add space if there's a right icon
          }}
          name={name}
          disabled={disabled}
        />
        {rightIcon && (
          <div style={{ position: "absolute", right: 10, zIndex: 1 }}>
            {rightIcon}
          </div>
        )}
      </div>
    </div>
  );
};

export default LabelInputField;
